import React from 'react'

import MultilineChart from '../../chartsData/MultipleLineChart'
import DoughnutChart from '../../chartsData/Doughnutdata'

import { Line, Doughnut } from 'react-chartjs-2'
import Loader from '../Loader'

import AbsentChart from '../Charts/AbsentChart'

import CardWithChart from '../CardWithChart'
import CardWithEmployeeList from '../CardWithEmployeeList'
import { NoDataFound } from '../NoDataFound'
import CommonDashboardLayout from '../CommonDashboardLayout'

export default function DashLayout({ loading, attendance }) {
  const cardData = [
    { heading: 'Total Employees', label: loading ? <Loader /> : attendance.totalEmployees },
    { heading: 'Absent', label: loading ? <Loader /> : attendance.totalAbsent },
    { heading: 'On Time', label: loading ? <Loader /> : attendance.totalPresent },
    { heading: 'Late', label: loading ? <Loader /> : attendance.totalLate },
    {
      heading: 'Productive Hours',
      label: loading ? <Loader /> : attendance.totalEmployees ? attendance.productiveHours : 0,
    },
  ]

  const totalData = (canvas) => {
    const ctx = canvas.getContext('2d')
    const gradient1 = ctx.createLinearGradient(206, 159, 252, 1)
    gradient1.addColorStop(0, '#CE9FFC')
    gradient1.addColorStop(1, '#7367F0')
    const gradient2 = ctx.createLinearGradient(116, 249, 241, 0)
    gradient2.addColorStop(0, '#74F9F1')
    gradient2.addColorStop(1, '#74F9F1')
    const gradient3 = ctx.createLinearGradient(255, 233, 133, 1)
    gradient3.addColorStop(0, '#FFE985')
    gradient3.addColorStop(1, '#FA742B')
    const gradient4 = ctx.createLinearGradient(255, 246, 183, 1)
    gradient4.addColorStop(0, '#FFF6B7')
    gradient4.addColorStop(1, '#F6416C')
    return {
      labels: ['Late', 'Absent', 'Present'],
      datasets: [
        {
          label: 'My First Dataset',
          data: [
            loading ? 0 : attendance.totalLate,
            loading ? 0 : attendance.totalAbsent,
            loading ? 0 : attendance.totalPresent,
          ],
          backgroundColor: [gradient2, gradient3, gradient4, gradient1],
          hoverOffset: 4,
        },
      ],
    }
  }

  const MultipleLinedata = (canvas) => {
    const ctx = canvas.getContext('2d')
    const gradient1 = ctx.createLinearGradient(55, 81, 255, 1)
    gradient1.addColorStop(0, ' blue')
    gradient1.addColorStop(1, '#F5F8FF')
    let arr = []
    Object.keys(loading ? {} : attendance.monthComparison).forEach((item) => {
      arr.push(Object.values(attendance.monthComparison[item]))
    })
    const data1 = {
      label: 'Current Month',
      data: arr[0],

      pointRadius: 0,
      borderColor: '#3751FF',
      tension: 0.4,
      fill: false,
      backgroundColor: gradient1,
    }

    const data2 = {
      label: 'Previous month',
      data: arr[1],

      pointRadius: 0,
      borderColor: '#05CFD3',
      tension: 0.4,
      fill: false,
      backgroundColor: 'rgba(245, 248, 255, 1)',
    }
    return {
      labels: ['Week1', 'Week2', 'Week3', 'Week4', 'Week5', 'Week 6'],

      datasets: [data1, data2],
    }
  }

  const LineChart = () => {
    return (
      <>
        {loading ? (
          <div style={{ padding: '28%' }}>
            <Loader />
          </div>
        ) : (
          <Line data={MultipleLinedata} options={MultilineChart.MultipleLinedataOptions} height={324} />
        )}

        {/* {Object.keys(attendance && attendance.monthComparison).length === 0 && <NoDataFound />} */}
      </>
    )
  }

  const PieChart1 = () => {
    return <Doughnut data={totalData} options={DoughnutChart.DoughnutOptions} />
  }
  const PieChart2 = () => {
    return <AbsentChart monthlyAbsent={attendance && attendance.absentRate} />
  }

  return (
    <>
      <CommonDashboardLayout
        array={cardData}
        lineChart={<LineChart />}
        piechart1={
          loading ? (
            <Loader />
          ) : !attendance.totalPresent && !attendance.totalAbsent && !attendance.totalLate ? (
            'No Data Found'
          ) : (
            <PieChart1 />
          )
        }
        piechart2={<PieChart2 />}
        employeeList={
          <CardWithEmployeeList
            heading="Absent Employee This Week"
            data={loading ? [] : attendance.absentThisWeek}
            employeeId="EmployeeId"
          />
        }
        heading1="Monthly Comparison of Absent Employees"
        heading2="Absent, Late %"
        heading3="Absent Rate"
      />
    </>
  )
}
